module.exports = __webpack_public_path__ + "img/583.58f40eb1.png";